import { useState } from 'react';
import { Modal, ModalControlProps } from '../../../layouts/Modal';
import { Button } from '../../base/Button';
import { ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';
import { LoadingWheel } from '../../base/LoadingWheel';
import { useNotification } from '../../../hooks/useNotifications';
import useOrganisationTokenMutations from '../../../data/organisation/useOrganisationTokenMutations';
import useOrganisation from '../../../data/organisation/useOrganisation';

interface MELPumpModalProps extends ModalControlProps { }

export function MELPumpModal({ open, onClose }: MELPumpModalProps) {
  const { create } = useOrganisationTokenMutations();
  const { organisation } = useOrganisation();
  const addNotification = useNotification();
  const [generatedToken, setGeneratedToken] = useState<string>();
  const [submitting, setSubmitting] = useState(false);

  const handleConnect = () => {
    setSubmitting(true);
    create.mutate(
      {
        tokenName: '__SYSTEM_MELPump',
        roleId: organisation.data?.adminRole!,
      },
      {
        onSuccess: (response) => {
          if (response.data?.data?.length > 0) {
            setGeneratedToken(response.data.data[0].key);
          } else {
            //TODO: handle error
          }
        },
        onError: (error) => {
          //TODO: handle error
        },
        onSettled: () => {
          setSubmitting(false);
        },
      }
    );
  };

  const handleCopy = (copyText: string) => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        addNotification('success', 'Token copied!');
      })
      .catch((_) => {
        addNotification('error', 'Failed to copy token');
      });
  };

  const handleClose = () => {
    setTimeout(() => {
      setGeneratedToken(undefined);
    }, 200);

    onClose(true);
  }

  return (
    <Modal open={open} onClose={onClose} title="Connect MEL Pump" dialogStatic>
      <p>Optimize your heat pump settings and save money effortlessly with MEL Pump's cutting-edge heat pump monitoring app</p>
      <div className="my-10 flex items-center justify-center">
        {submitting || organisation.isLoading ? (
          <LoadingWheel />
        ) : !generatedToken ? (
          <Button size="lg" onClick={handleConnect}>
            Connect MEL Pump
          </Button>
        ) : (
          <div>
            Please copy this token and enter it in the MEL Pump application to
            complete the connection, this token will not be shown again.
            <div className="mt-2 p-4 rounded-md dark:bg-gray-100/40 flex flex-row items-center space-x-2 ">
              <code className="break-all text-sm">{generatedToken}</code>
              <Button variant="outlined" onClick={() => handleCopy(generatedToken)}>
                <ClipboardDocumentCheckIcon className="h-5 w-5" />
              </Button>
            </div>
          </div>
        )}
      </div>
      <div>
        <Button onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
}
